import React, { useState } from 'react'
import { useLanguageStore } from '../../../../store/useLanguageStore';
import { useDarkModeStore } from '../../../../store/useDarkModeStore';
import { darkModeBackgroudInputs } from '../../../../utils/constants';
import { TicketInterface } from '../../../../models/TicketModule/Ticket';
import ToastMessage from '../../../../common/ToastMessage';
import useStatuses from '../../../../store/ReactQueries/statuses/useStatus';
import useUpdateTicketStatus from '../../../../store/ReactQueries/tickets/useUpdateTicketStatus';

interface SelectStatusProps {
    page: number;
    statusId: string;
    pageSize: number;
    ticket: TicketInterface | undefined;
}

export const SelectStatus: React.FC<SelectStatusProps> = ({ ticket, statusId, page, pageSize }) => {

    const { language } = useLanguageStore();
    const { darkMode } = useDarkModeStore();
    const { data: statuses } = useStatuses(0, 0);

    const [selectedItem, setSelectedItem] = useState<string>(statusId);

    const updateAssetStatus = useUpdateTicketStatus(page, pageSize);

    const handleSelect = (e: React.ChangeEvent<HTMLSelectElement>) => {
        const { value } = e.target;
        if (ticket) {
            setSelectedItem(value);
            const upForm = { ...ticket, statusId: value }
            updateAssetStatus.mutate(upForm, {
                onSuccess: () => ToastMessage.Success(),
                onError: (error) => {
                    setSelectedItem(ticket.statusId);
                    ToastMessage.Failed(error.message);
                },
            }
            )
        }
    };

    return (
        <div className='d-flex flex-row align-items-center gap-1' title={language['AssetStatuses']}>
            <div style={{ width: 10, height: 10, background: ticket?.status?.badgeColor ? ticket.status.badgeColor : '#A0D76A' }} />
            <select
                className='select-asset'
                style={{
                    color: darkMode ? 'white' : 'initial',
                    background: darkMode ? darkModeBackgroudInputs : 'white',
                }}
                value={selectedItem}
                onChange={(e) => {
                    e.preventDefault();
                    handleSelect(e);
                }}
                onClick={(e) => e.stopPropagation()}
            >
                {statuses?.map(({ id, title }) => <option key={id} value={id}>{title}</option>)}
            </select>
        </div>
    );
}
export default SelectStatus